import React from 'react';
import { Controller } from 'react-hook-form';

export const FieldController = (props) => <Controller {...props} />;
